import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1ebcac49&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ebcac49')) {
      api.createRecord('1ebcac49', component.options)
    } else {
      api.reload('1ebcac49', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=1ebcac49&", function () {
      api.rerender('1ebcac49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "examples/App.vue"
export default component.exports